export enum FundsRequestCompletionType {
  Approve = 'approve',
  Reject = 'cancel',
}
